import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { getAuthLinkJWT } from 'firebase/callables';
import { Loading, EmptyState } from '@antlerengineering/components';
import { auth } from '../../firebase';
enum PageStates {
  fetching = 'FETCHING',
  authenticating = 'AUTHENTICATING',
  expired = 'expired',
  invalid = 'INVALID',
}

export default function AuthLinkPage() {
  const [state, setState] = useState(PageStates.fetching);

  const handleAuth = async (id, key) => {
    const resp = await getAuthLinkJWT(id, key);
    if (resp.data.success) {
      setState(PageStates.authenticating);
      await auth.signInWithCustomToken(resp.data.jwt);

      window.location.replace(resp.data.redirectPath);
    } else {
      setState(PageStates.invalid);
    }
  };
  useEffect(() => {
    const { id, key } = queryString.parse(window.location.search);

    if (typeof id === 'string' && typeof key === 'string') {
      handleAuth(id, key);
    } else {
      setState(PageStates.invalid);
    }
  }, []);

  switch (state) {
    case PageStates.fetching:
      return <Loading fullScreen message="Getting your key" />;
    case PageStates.authenticating:
      return <Loading fullScreen message="Authenticating you" />;
    default:
      return <EmptyState message="fail" />;
  }
}
